export enum CardDetailsSource {
    SIDEPANEL = "SIDEPANEL",
    CARD = "CARD",
}

export type additionalElements = {
    render: JSX.Element;
    visible: boolean;
};

export type CardDetail = {
    label: string;
    value: string | undefined;
    renderOn?: CardDetailsSource[];
    lineClamp?: number;
    loading?: boolean;
    tertiaryText?: string;
    expandable?: boolean;
    additionalElements?: additionalElements[];
    showTooltip?: boolean;
    logExpandClick?: boolean;
    contentId?: string;
    contentType?: string;
};
